module.exports = __webpack_public_path__ + "img/id-jb.ce27aa59.svg";